import { SingleSale } from '@spike/single-sale-model';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { FunctionComponent } from 'react';
import styles from './SalesTableRow.module.scss';

interface SalesTableRowProps {
    sale: SingleSale;
    timeZone: string;
    onClick: () => void;
}

const formatMoney = (value: string) => `$${Number(value || 0).toFixed(2)}`;

const getStatusLabel = (status: string) => {
    switch (status) {
        case 'completed':
            return 'Completed';
        case 'unpaid':
            return 'Pending';
        case 'incomplete':
            return 'Incomplete';
        case 'voided':
            return 'Voided';
        default:
            return status;
    }
};

export const SalesTableRow: FunctionComponent<SalesTableRowProps> = ({ sale, timeZone, onClick }) => (
    <TableRow
        className={styles.row}
        onClick={onClick}
    >
        <TableCell className={styles.dateCell}>
            <div className={styles.date}>{sale.issuedAt.clone().tz(timeZone).format('MM/DD/YYYY, h:mm a')}</div>
            <div className={styles.location}>{sale.marketplaceName}</div>
        </TableCell>
        <TableCell className={styles.clientCell}>{sale.client?.name ?? '-'}</TableCell>
        <TableCell className={styles.itemsCell}>{sale.itemsCount}</TableCell>
        <TableCell className={styles.totalCell}>{formatMoney(sale.total)}</TableCell>
        <TableCell className={styles.statusCell}>
            <span className={`${styles.status} ${styles[`status-${sale.status}`] ?? ''}`}>
                {getStatusLabel(sale.status)}
            </span>
        </TableCell>
    </TableRow>
);

export default SalesTableRow;
